
export default class NetworkLite {

    id!: number;
    name!: string;

    public static fromResponse(data: any): NetworkLite {

        const result: NetworkLite = new NetworkLite();

        if (data.id != undefined) {
            result.id = data.id;
        }

        if (data.name != undefined) {
            result.name = data.name;
        }

        return result;

    }

}